import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { relatorioAction, usuarioAction, fazendaAction } from '../_actions';
import Select from 'react-select';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Input, Label, Row, Col
} from 'reactstrap';
import Swal from 'sweetalert2';

export const ModalRelatorioVisitas = ({ openModal, handleClose, props }) => {
    const dispatch = useDispatch();
    const usuarios = useSelector(state => state.usuario.usuario);
    const fazendas = useSelector(state => state.fazenda.fazenda);

    const [filtros, setFiltros] = useState({
        data_inicio: '',
        data_termino: '',
        id_usuario: '0',
        tipo_visita: 'VT'
    });

    const optionsTipoVisita = [
        { value: 'VT', label: 'VISITA TÉCNICA' },
        { value: 'VV', label: 'VETERINÁRIO' },
        { value: '', label: 'TODOS OS TIPOS' }
    ];

    useEffect(() => {
        if (openModal) {
            dispatch(usuarioAction.getSelectAdministradores());
        }
    }, [openModal, dispatch]);

    const handleChange = (prop) => (event) => {
        setFiltros({ ...filtros, [prop]: event.target.value });
    };

    const handleSelectChange = (prop) => (event) => {
        setFiltros({ ...filtros, [prop]: event.value });
    };

    const handleValidation = () => {
        let valid = true;
        let errors = '';

        if (!filtros.data_inicio) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de início!</li><br>';
        }
        if (!filtros.data_termino) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de fim!</li><br>';
        }
        if (filtros.data_inicio && filtros.data_termino && filtros.data_termino < filtros.data_inicio) {
            valid = false;
            errors += '<li style="float:left;">Data de término não pode ser menor que a data de início!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const handleGerarRelatorio = (event) => {
        event.preventDefault();
        if (handleValidation()) {
            let payload = {
                tipo_relatorio: "VI",
                data_inicio: filtros.data_inicio,
                data_termino: filtros.data_termino,
                id_usuario: filtros.id_usuario !== '0' ? filtros.id_usuario : 0,
                tipo_visita: filtros.tipo_visita
            };
            dispatch(relatorioAction.getRelatorio(payload, true));
            handleClose();
        }
    };

    const renderOptionsUsuarios = () => {
        const users = (usuarios || []).map((p) => ({
            value: p.Value, label: p.Text
        }));
        return [{ value: '0', label: 'TODOS OS TÉCNICOS' }, ...users];
    };

    return (
        <Modal isOpen={openModal} toggle={handleClose} size="lg">
            <ModalHeader toggle={handleClose}>Fazendas sem Relatório de Visita</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label className="font-weight-bold small text-uppercase" for="data_inicio">Data início *</Label>
                            <Input
                                id="data_inicio"
                                type="date"
                                value={filtros.data_inicio}
                                onChange={handleChange('data_inicio')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label className="font-weight-bold small text-uppercase" for="data_termino">Data término *</Label>
                            <Input
                                id="data_termino"
                                type="date"
                                value={filtros.data_termino}
                                onChange={handleChange('data_termino')}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Label className="font-weight-bold small text-uppercase" for="id_usuario">Técnico</Label>
                            <Select
                                classNamePrefix="select"
                                value={renderOptionsUsuarios().find(opt => opt.value == filtros.id_usuario)}
                                placeholder="Todos os técnicos..."
                                onChange={handleSelectChange('id_usuario')}
                                isSearchable
                                options={renderOptionsUsuarios()}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Label className="font-weight-bold small text-uppercase" for="tipo_visita">Tipo de Visita</Label>
                            <Select
                                classNamePrefix="select"
                                value={optionsTipoVisita.find(opt => opt.value === filtros.tipo_visita)}
                                onChange={handleSelectChange('tipo_visita')}
                                isSearchable={false}
                                options={optionsTipoVisita}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleClose}>Cancelar</Button>
                <Button color="primary" onClick={handleGerarRelatorio}>Gerar Relatório</Button>
            </ModalFooter>
        </Modal>
    );
};
